// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2uKrI","checkboxCol":"Table_checkboxCol__1Gotg","emailCol":"Table_emailCol__1aw6E","actionCol":"Table_actionCol__2gZlI"};